import { addedLazyLoadImages } from "@/scripts/helpers/imgLazyload";
import { showMore } from "@/scripts/helpers/library";
import { initWowLibrary } from "@/scripts/helpers/wowAnimation";
import Accordion from "@/modules/containers/accordion";
import "slick-carousel/slick/slick";
import contactForm from "@/modules/blocks/contact-form/index";
import modalShow from "@/modules/containers/modal/modal";
import modalFullScreen from "@/modules/containers/modal-full-screen/index";

const workflowAutomationSlider = () => {
  const navigation = $(".js-slider-workflow-navigation");
  const viewport = $(".js-slider-workflow-viewport");

  viewport.slick({
    arrows: true,
    cssEase: "cubic-bezier(0.6, 0, 0.3, 1)",
    draggable: false,
    dots: false,
    fade: true,
    focusOnSelect: true,
    lazyLoad: "ondemand",
    speed: 700,
    pauseOnHover: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: ".js-slider-workflow-navigation"
  });

  navigation.slick({
    asNavFor: ".js-slider-workflow-viewport",
    arrows: false,
    centerMode: false,
    dots: false,
    draggable: false,
    fade: false,
    focusOnSelect: true,
    infinite: true,
    pauseOnHover: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    swipe: false,
    responsive: [
      {
        breakpoint: 959,
        settings: "unslick"
      }
    ]
  });

  $(".slide-navigation").on("click keyup", function() {
    const slideIndex = $(this)
      .closest(".slick-slide")
      .attr("data-slick-index");
    viewport.slick("slickGoTo", slideIndex);
  });
};

const initTableShowMore = () => {
  showMore(
    ".js-services-comparison-table",
    ".page-section--competition .js-button-show-more",
    undefined,
    true
  );
};

function stickyTableHeader() {
  const targetWidth = $(".services-comparison-table__tbody").width();

  if ($(".js-services-comparison-table").length) {
    $(window).scroll(function() {
      const fromTop = window.pageYOffset;
      const tableHeader = $(".services-comparison-table__thead");
      const startPoint = $(".js-services-comparison-table");
      const offsetTop = startPoint.offset().top;
      const offsetBottom = startPoint.innerHeight();
      const stopPoint = offsetTop + offsetBottom;
      const tabletBreakpoint = 960;
      const windowWidth = $(window).width();
      var marginTop = 0;
      const headerSticky = $(".pinned-header");

      if (headerSticky && tabletBreakpoint < windowWidth) {
        marginTop = 78;
      } else if (headerSticky && tabletBreakpoint > windowWidth) {
        marginTop = 76;
      } else {
        marginTop = 0;
      }

      if (
        fromTop >= offsetTop - marginTop &&
        fromTop <= stopPoint - (marginTop + tableHeader.height())
      ) {
        tableHeader.addClass("is-sticky");
        startPoint.addClass("is-active");
      } else {
        tableHeader.removeClass("is-sticky");
        startPoint.removeClass("is-active");
      }

      const overflowBlock = $(".table-wrapper");
      let position = overflowBlock.scrollLeft();
      const servicesHeaderSticky = $(
        ".services-comparison-table__thead.is-sticky"
      );

      if (servicesHeaderSticky.length) {
        $(".services-comparison-table__thead").css(
          "left",
          "-" + position + "px"
        );
      }
    });

    $(".table-wrapper").scroll(function() {
      let position = $(this).scrollLeft();
      if ($(".services-comparison-table__thead.is-sticky").length) {
        $(".services-comparison-table__thead").css(
          "left",
          "-" + position + "px"
        );
      }
    });

    $(".services-comparison-table__thead").css("width", targetWidth);
  }
}

$(document).ready(function() {
  addedLazyLoadImages();
  Accordion();
  workflowAutomationSlider();
  initWowLibrary();
  initTableShowMore();
  stickyTableHeader();
  modalShow();
  modalFullScreen();
  contactForm();

  $("[data-micromodal-trigger]").click(function(e) {
    e.preventDefault();
  });

  $(window).on("resize", function() {
    stickyTableHeader();
  });
});
